import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as CommonFunctions from "../functions/commonFunctions";
import * as GC from "../../../../common/common";

class CreateObligations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //post this.state.actief: true,
      omschrijving: "",
      startJaar: "",
      eindJaar: "",
      datumaanvang: null,
      datumoplevering: null,
      opdrachtgever: "",
      eenheid: "",
      eenheidsprijs: 0,
      kostentotaal: 0,
      kostenperjaar: 0,
      opmerking: "",
      akkoord: true,
      actief: true,
      hoeveelheid: "",
      boekingsnummer: "",
      omschrijvingRequiredAlert: "",
      omschrijvingAlertText: "",
      code: GC.CodeAutoFill("VP"),
      codeRequiredAlert: false,
      codeAlertText: "",
      //budget
      handleSelectBudget: false,
      budgets: [],
      selectedBudget: null,
      selectedBudgetId: null,
      selectedBudgetCode: null,
      //werkplan
      handleSelectWerkplan: false,
      werkplans: [],
      selectedWerkplan: null,
      selectedWerkplanId: null,
      selectedWerkplanCode: null,
      //Organisatie
      handleSelectOrganization: false,
      organizations: [],
      selectedOrganization: null,
      selectedOrganizationId: null,
      //Directievoerder
      handleSelectDirectievoerder: false,
      directievoerders: [],
      selectedDirectievoerder: null,
      selectedDirectievoerderId: null,
      //Toezichthouder
      handleSelectToezichthouder: false,
      toezichthouders: [],
      selectedToezichthouder: null,
      selectedToezichthouderId: null,
      //file
      formDataPost: null,
      file: null,
      // kabul edilen media tipleri
      acceptFileType: [
        "text/plain",
        "image/png",
        "image/jpeg",
        "image/jpg",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
      ],
    };
    this.baseState = this.state;
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  resetForm = async () => {
    await this.setState(this.baseState);
    await this.setState({ code: GC.CodeAutoFill("VP") });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    if (value != "" && name == "begin") {
      this.setState({ beginRequiredAlert: false });
    }
    if (value != "" && name == "end") {
      this.setState({ endRequiredAlert: false });
    }
    if (value != "" && name == "naam") {
      this.setState({ naamRequiredAlert: false });
    }
  }

  async handleSubmit(event) {
    event.preventDefault();
    $("#cover-spin").show(0);

    var horizon_begin = this.state.begin + "T00:00:00.000Z";
    var horizon_end = this.state.end + "T00:00:00.000Z";
    this.state.omschrijving == ""
      ? await this.setState({
          omschrijvingRequiredAlert: true,
          omschrijvingAlertText: "required",
        })
      : await this.setState({
          omschrijvingRequiredAlert: false,
          omschrijvingAlertText: "",
        });
    this.state.code == ""
      ? await this.setState({
          codeRequiredAlert: true,
          codeAlertText: "required",
        })
      : await this.setState({ codeRequiredAlert: false, codeAlertText: "" });
    var model = {
      relationships: { definition: { code: "VERPLICHTING" } },
      content: {
        algemeen: {
          omschrijving: this.state.omschrijving,
          code: this.state.code,
          starteneindjaar: [
            this.state.startJaar + "-01-01T00:00:00.000Z",
            this.state.eindJaar + "-01-01T00:00:00.000Z",
          ],
          // datumaanvang: this.state.datumaanvang,
          // datumoplevering: this.state.datumoplevering,
          opdrachtgever: this.state.opdrachtgever,
          eenheid: this.state.eenheid,
          eenheidsprijs: this.state.eenheidsprijs,
          kostentotaal: this.state.kostentotaal,
          kostenperjaar: this.state.kostenperjaar,
          opmerking: this.state.opmerking,
          akkoord: this.state.akkoord,
          actief: this.state.actief,
        },
      },
    };

    if (this.state.datumaanvang) {
      model.content.algemeen.datumaanvang = this.state.datumaanvang;
    }
    if (this.state.datumoplevering) {
      model.content.algemeen.datumoplevering = this.state.datumoplevering;
    }

    let isUnique = true;
    let uniqueModel = {
      content: [
        {
          and_or: "AND",
          datatype: "STRING",
          key: "algemeen-code",
          values: [this.state.code],
        },
      ],
      definitions: [process.env.REACT_APP_USER_OBLIGATIONS],
      sorting: [],
    };

    //** code isunique control.
    await omnimap
      .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
      .then((result) => {
        if (result.data && result.data.length > 0) {
          isUnique = false;
          this.setState({
            codeRequiredAlert: true,
            codeAlertText: "is not unique",
          });
        }
      });

    if (
      this.state.omschrijvingRequiredAlert !== true &&
      this.state.codeRequiredAlert !== true &&
      isUnique === true
    ) {
      var data = await omnimap.SaveOrEditAction(
        model,
        "POST",
        "",
        window.$catalog_management_units_token
      );
      if (data.result.status === "OK") {
        CallBackFunctions.SubmitCallBack(window.$mm_management_units_token);

        GC.sleep(1000).then(async () => {
          // Directievoerder
          await GC.StartActivity(
            {
              directievoerder: {
                identification: this.state.selectedDirectievoerderId,
                display: [
                  {
                    path: "$.alias",
                    value: this.state.selectedDirectievoerder,
                  },
                ],
              },
              naamdirectievoerder: this.state.selectedDirectievoerder,
            },
            [data.data.identification],
            "cb6279b4-99db-4003-a93a-193d560a41fd",
            null,
            window.$mm_management_units_token
          );
          // toezichthouder
          await GC.StartActivity(
            {
              toezichthouder: {
                identification: this.state.selectedToezichthouderId,
                display: [
                  { path: "$.alias", value: this.state.selectedToezichthouder },
                ],
              },
              naamtoezichthouder: this.state.selectedToezichthouder,
            },
            [data.data.identification],
            "b905237c-e32e-4c3c-8f5d-6afec5366736",
            null,
            window.$mm_management_units_token
          );

          // toezichthouder
          await GC.StartActivity(
            {
              organisatie: this.state.selectedOrganizationId,
              naamorganisatie: this.state.selectedOrganization,
            },
            [data.data.identification],
            "4fc3522e-d36d-4d67-8d71-34b16917d590",
            null,
            window.$mm_management_units_token
          );

          // budget
          await GC.StartActivity(
            {
              budget: this.state.selectedBudgetId,
              naambudget: this.state.selectedBudget,
            },
            [data.data.identification],
            "c75bb9f9-63cc-4335-91e2-24cf7ba28067",
            null,
            window.$mm_management_units_token
          );
          // werkplan
          await GC.StartActivity(
            {
              werkplan: this.state.selectedWerkplanId,
              naamwerkplan: this.state.selectedWerkplan,
            },
            [data.data.identification],
            "744fae0c-2dff-4999-99b5-6cf99f9d3390",
            null,
            window.$mm_management_units_token
          );
          // document
          await omnimap
            .PostMediaAction(
              this.state.formDataPost,
              data.data.identification,
              window.$mm_management_units_token
            )
            .then(async (result) => {
              await this.setState({
                formDataPost: null,
                file: null,
              });
              await $("#cover-spin").hide(0);
            });
        });
      }
    } else {
      $("#cover-spin").hide(0);
    }
  }

  // budget
  async getBudgets() {
    const budgets = await omnimap.FillTableAction(
      {
        content: [
          {
            key: "algemeen-actief",
            and_or: "AND",
            values: [true],
            datatype: "BOOLEAN",
          },
        ],
        definitions: [process.env.REACT_APP_CATALOG_BUDGET],
      },
      1,
      window.$mm_management_units_token
    );
    await this.setState({ budgets: budgets.data });
  }
  async handleBudget(budget, e) {
    const element = e.target;

    await this.setState({
      selectedBudget: budget ? budget.name : null,
      selectedBudgetId: budget ? budget.identification : null,
      selectedBudgetCode: budget ? budget.content["algemeen-code"] : null,
    });
  }
  // werkplan
  async getWerkplans() {
    const werkplans = await omnimap.FillTableAction(
      {
        content: [
          {
            key: "algemeen-actief",
            and_or: "AND",
            values: [true],
            datatype: "BOOLEAN",
          },
        ],
        definitions: [process.env.REACT_APP_CATALOG_WORK_PLANS],
      },
      1,
      window.$mm_management_units_token
    );
    await this.setState({ werkplans: werkplans.data });
  }
  async handleWerkplan(werkplan, e) {
    await this.setState({
      selectedWerkplan: werkplan ? werkplan.name : null,
      selectedWerkplanId: werkplan ? werkplan.identification : null,
      selectedWerkplanCode: werkplan ? werkplan.content["algemeen-code"] : null,
    });
  }
  // organization
  async getOrganization() {
    const organizations = await omnimap.FillTableAction(
      {
        content: [
          {
            key: "algemeen-actief",
            and_or: "AND",
            values: [true],
            datatype: "BOOLEAN",
          },
        ],
        definitions: [process.env.REACT_APP_USER_ORGANISATION],
      },
      1,
      window.$mm_management_units_token
    );
    await this.setState({ organizations: organizations.data });
  }
  async handleOrganization(organization, e) {
    await this.setState({
      selectedOrganization: organization ? organization.name : null,
      selectedOrganizationId: organization ? organization.identification : null,
    });
  }
  // Directievoerder
  async getDirectievoerder() {
    const directievoerders = await omnimap.GetUserByRoleAction(
      1,
      30,
      "Directievoerder",
      window.$mm_management_units_token
    );

    await this.setState({ directievoerders: directievoerders.data });
  }
  async handleDirectievoerder(directievoerder, e) {
    await this.setState({
      selectedDirectievoerder: directievoerder ? directievoerder.alias : null,
      selectedDirectievoerderId: directievoerder
        ? directievoerder.identification
        : null,
    });
  }
  // Toezichthouder
  async getToezichthouder() {
    const toezichthouders = await omnimap.GetUserByRoleAction(
      1,
      30,
      "Toezichthouder",
      window.$mm_management_units_token
    );
    await omnimap.FillTableAction(
      {
        content: [
          {
            key: "algemeen-actief",
            and_or: "AND",
            values: [true],
            datatype: "BOOLEAN",
          },
        ],
        definitions: [process.env.REACT_APP_USER_ORGANISATION],
      },
      1,
      window.$mm_management_units_token
    );
    await this.setState({ toezichthouders: toezichthouders.data });
  }
  async handleToezichthouder(toezichthouder, e) {
    await this.setState({
      selectedToezichthouder: toezichthouder ? toezichthouder.alias : null,
      selectedToezichthouderId: toezichthouder
        ? toezichthouder.identification
        : null,
    });
  }
  /**
   * * dosya seçildiğinde çalışan fonksiyon
   *
   * @param {event}
   * e parametresi biz source'dan seçilen file bilgilerine ulaşmamızı sağlar
   */
  fileOnChange = (e) => {
    let file = e.target.files[0];
    if (this.state.acceptFileType.includes(file.type)) {
      const formData = new FormData();
      formData.append("content", file);
      formData.append(
        "metadata",
        `{"filename":"${file.name}","description":"","mime_type":"${file.type}","definition_code":"TEST"}`
      );

      this.setState({ formDataPost: formData, file: file });
    } else alert("invalid media type");
  };

  /**
   * * yüklenecek dosya vazgeçildinde çalışan fonksiyon
   */
  fileUnSelect() {
    this.setState({ formDataPost: null, file: null });
  }

  async componentDidMount() {
    var that = this;
    $(document).on("click", "#beheereenheid_toevoegen", function () {
      $("#obligations_toevoegen_modal").modal("show");
      that.getBudgets();
      that.getWerkplans();
      that.getOrganization();
      that.getDirectievoerder();
      that.getToezichthouder();
      CommonFunctions.GetColumnProperties("create");
      that.resetForm();
    });
  }

  render() {
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="obligations_toevoegen_modal"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Toevoegen aan verplichtingen</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div>
                <div className="form-group row">
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                    style={
                      this.state.codeRequiredAlert ? { color: "red " } : null
                    }
                  >
                    Code*{"\u00A0"}
                    {this.state.codeRequiredAlert
                      ? this.state.codeAlertText
                      : ""}
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control"
                      name="code"
                      value={this.state.code}
                      autocomplete="off"
                      onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="inputPassword"
                    className="col-sm-2 col-form-label"
                    style={
                      this.state.omschrijvingRequiredAlert
                        ? { color: "red " }
                        : null
                    }
                  >
                    Omschrijving*{"\u00A0"}
                    {this.state.omschrijvingRequiredAlert
                      ? this.state.omschrijvingAlertText
                      : ""}
                  </label>
                  <div className="col-sm-10">
                    <textarea
                      class="form-control"
                      // placeholder="Budget en werkplan"
                      rows="3"
                      name="omschrijving"
                      value={this.state.omschrijving}
                      autocomplete="off"
                      onChange={this.handleInputChange}
                    ></textarea>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Budget
                  </label>
                  <div className="col-sm-10">
                    <div
                      className={
                        this.state.handleSelectBudget
                          ? "select-content open"
                          : "select-content"
                      }
                      onClick={() =>
                        this.setState({
                          handleSelectBudget: !this.state.handleSelectBudget,
                        })
                      }
                    >
                      <input
                        type="text"
                        className="form-control"
                        disabled
                        value={
                          this.state.selectedBudget !== null
                            ? `[${this.state.selectedBudgetCode}] ${this.state.selectedBudget}`
                            : ""
                        }
                        placeholder="selecteer"
                      />
                      <div class="popup-dropdown">
                        <span
                          className={
                            this.state.handleSelectBudget
                              ? "popuptext-dropdown show modaldropdown"
                              : "popuptext-dropdown"
                          }
                        >
                          <a
                            class="a-popuptext-dropdown-a"
                            onClick={this.handleBudget.bind(this, null)}
                          >
                            selecteer
                          </a>
                          {this.state.budgets.map((m) => (
                            <a
                              class="a-popuptext-dropdown-a"
                              name={m.name}
                              onClick={this.handleBudget.bind(this, m)}
                            >
                              [{m.content["algemeen-code"]}] {"\u00A0"} {m.name}
                            </a>
                          ))}
                        </span>
                      </div>

                      {/* <select class="form-control" id="e-eenheid" hidden></select> */}
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Werkplan
                  </label>

                  <div className="col-sm-10">
                    <div
                      className={
                        this.state.handleSelectWerkplan
                          ? "select-content open"
                          : "select-content"
                      }
                      onClick={() =>
                        this.setState({
                          handleSelectWerkplan:
                            !this.state.handleSelectWerkplan,
                        })
                      }
                    >
                      <input
                        type="text"
                        className="form-control"
                        disabled
                        value={
                          this.state.selectedWerkplan !== null
                            ? `[${this.state.selectedWerkplanCode}] ${this.state.selectedWerkplan}`
                            : ""
                        }
                        placeholder="selecteer"
                      />
                      <div class="popup-dropdown">
                        <span
                          className={
                            this.state.handleSelectWerkplan
                              ? "popuptext-dropdown show modaldropdown"
                              : "popuptext-dropdown"
                          }
                        >
                          <a
                            class="a-popuptext-dropdown-a"
                            onClick={this.handleWerkplan.bind(this, null)}
                          >
                            selecteer
                          </a>
                          {this.state.werkplans.map((m) => (
                            <a
                              class="a-popuptext-dropdown-a"
                              name={m.name}
                              onClick={this.handleWerkplan.bind(this, m)}
                            >
                              [{m.content["algemeen-code"]}] {"\u00A0"} {m.name}
                            </a>
                          ))}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Boekingsnummer / Maatregel
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control"
                      name="boekingsnummer"
                      value={this.state.boekingsnummer}
                      onChange={this.handleInputChange}
                      autocomplete="off"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Looptijd
                  </label>
                  <div className="col-sm-5">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Start jaar"
                      min="0"
                      name="startJaar"
                      value={this.state.startJaar}
                      onChange={this.handleInputChange}
                      autocomplete="off"
                    />
                  </div>
                  <div className="col-sm-5">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Eind jaar"
                      min="0"
                      name="eindJaar"
                      value={this.state.eindJaar}
                      onChange={this.handleInputChange}
                      autocomplete="off"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Datum aanvraag
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="date"
                      className="form-control"
                      name="datumaanvang"
                      value={this.state.datumaanvang}
                      onChange={this.handleInputChange}
                      autocomplete="off"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label">
                    Datum oplevering
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="date"
                      className="form-control"
                      name="datumoplevering"
                      value={this.state.datumoplevering}
                      onChange={this.handleInputChange}
                      autocomplete="off"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Organisatie
                  </label>
                  <div className="col-sm-10">
                    <div
                      className={
                        this.state.handleSelectOrganization
                          ? "select-content open"
                          : "select-content"
                      }
                      onClick={() =>
                        this.setState({
                          handleSelectOrganization:
                            !this.state.handleSelectOrganization,
                        })
                      }
                    >
                      <input
                        type="text"
                        className="form-control"
                        disabled
                        value={
                          this.state.selectedOrganization !== null
                            ? this.state.selectedOrganization
                            : ""
                        }
                        placeholder="selecteer"
                      />
                      <div class="popup-dropdown">
                        <span
                          className={
                            this.state.handleSelectOrganization
                              ? "popuptext-dropdown show modaldropdown"
                              : "popuptext-dropdown"
                          }
                        >
                          <a
                            class="a-popuptext-dropdown-a"
                            onClick={this.handleOrganization.bind(this, null)}
                          >
                            selecteer
                          </a>
                          {this.state.organizations.map((m) => (
                            <a
                              class="a-popuptext-dropdown-a"
                              name={m.name}
                              onClick={this.handleOrganization.bind(this, m)}
                            >
                              {m.name}
                            </a>
                          ))}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Opdrachtgever
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control"
                      name="opdrachtgever"
                      value={this.state.opdrachtgever}
                      onChange={this.handleInputChange}
                      autocomplete="off"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Directievoerder
                  </label>
                  <div className="col-sm-10">
                    <div
                      className={
                        this.state.handleSelectDirectievoerder
                          ? "select-content open"
                          : "select-content"
                      }
                      onClick={() =>
                        this.setState({
                          handleSelectDirectievoerder:
                            !this.state.handleSelectDirectievoerder,
                        })
                      }
                    >
                      <input
                        type="text"
                        className="form-control"
                        disabled
                        value={
                          this.state.selectedDirectievoerder !== null
                            ? this.state.selectedDirectievoerder
                            : ""
                        }
                        placeholder="selecteer"
                      />
                      <div class="popup-dropdown">
                        <span
                          className={
                            this.state.handleSelectDirectievoerder
                              ? "popuptext-dropdown show modaldropdown"
                              : "popuptext-dropdown"
                          }
                        >
                          <a
                            class="a-popuptext-dropdown-a"
                            onClick={this.handleDirectievoerder.bind(
                              this,
                              null
                            )}
                          >
                            selecteer
                          </a>
                          {this.state.directievoerders.map((m) => (
                            <a
                              class="a-popuptext-dropdown-a"
                              name={m.alias}
                              onClick={this.handleDirectievoerder.bind(this, m)}
                            >
                              {m.alias}
                            </a>
                          ))}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Toezichthouder
                  </label>
                  <div className="col-sm-10">
                    <div
                      className={
                        this.state.handleSelectToezichthouder
                          ? "select-content open"
                          : "select-content"
                      }
                      onClick={() =>
                        this.setState({
                          handleSelectToezichthouder:
                            !this.state.handleSelectToezichthouder,
                        })
                      }
                    >
                      <input
                        type="text"
                        className="form-control"
                        disabled
                        value={
                          this.state.selectedToezichthouder
                            ? this.state.selectedToezichthouder
                            : ""
                        }
                        placeholder="selecteer"
                      />
                      <div class="popup-dropdown">
                        <span
                          className={
                            this.state.handleSelectToezichthouder
                              ? "popuptext-dropdown show modaldropdown"
                              : "popuptext-dropdown"
                          }
                        >
                          <a
                            class="a-popuptext-dropdown-a"
                            onClick={this.handleToezichthouder.bind(this, null)}
                          >
                            selecteer
                          </a>
                          {this.state.toezichthouders.map((m) => (
                            <a
                              class="a-popuptext-dropdown-a"
                              name={m.alias}
                              onClick={this.handleToezichthouder.bind(this, m)}
                            >
                              {m.alias}
                            </a>
                          ))}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Hoeveelheid
                  </label>
                  <div className="col-sm-4">
                    <input
                      type="number"
                      className="form-control"
                      name="hoeveelheid"
                      value={this.state.hoeveelheid}
                      onChange={this.handleInputChange}
                      autocomplete="off"
                    />
                  </div>
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Eenheid
                  </label>
                  <div className="col-sm-4">
                    <select
                      class="form-control"
                      id="obligations-eenheid"
                      class="form-control"
                      name="eenheid"
                      value={this.state.eenheid}
                      onChange={this.handleInputChange}
                    ></select>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Eenheidsprijs (€)
                  </label>
                  <div className="col-sm-4">
                    <input
                      type="number"
                      min={0}
                      className="form-control"
                      name="eenheidsprijs"
                      value={this.state.eenheidsprijs}
                      onChange={this.handleInputChange}
                      autocomplete="off"
                    />
                  </div>
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Totaal (€)
                  </label>
                  <div className="col-sm-4">
                    <input
                      type="number"
                      min={0}
                      className="form-control"
                      name="kostentotaal"
                      value={this.state.kostentotaal}
                      onChange={this.handleInputChange}
                      autocomplete="off"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Kosten per jaar (€)
                  </label>
                  <div className="col-sm-4">
                    <input
                      type="number"
                      min={0}
                      className="form-control"
                      name="kostenperjaar"
                      value={this.state.kostenperjaar}
                      onChange={this.handleInputChange}
                      autocomplete="off"
                    />
                  </div>
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Contract
                  </label>
                  <div className="col-sm-4">
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Document
                  </label>
                  <div className="col-sm-10">
                    <div class="upload-content">
                      <span class="upload-ico"></span>
                      <input
                        type="file"
                        id="upload"
                        hidden
                        onChange={this.fileOnChange.bind(this)}
                      />
                      <label for="upload">
                        {this.state.file !== null
                          ? `Bestand met de naam ${this.state.file.name} is geselecteerd`
                          : "Voeg bestand toe…"}{" "}
                      </label>
                      {this.state.file !== null ? (
                        <span
                          class="close-ico"
                          onClick={this.fileUnSelect.bind(this)}
                        ></span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="inputPassword"
                    className="col-sm-2 col-form-label"
                  >
                    Opmerking
                  </label>
                  <div className="col-sm-10">
                    <textarea
                      class="form-control"
                      placeholder="Dubbel"
                      rows="3"
                      name="opmerking"
                      value={this.state.opmerking}
                      autocomplete="off"
                      onChange={this.handleInputChange}
                    ></textarea>
                  </div>
                </div>
              </div>
              <label>Akkoord</label>
              <label className="switch">
                <input
                  id="beheereenheid_active"
                  type="checkbox"
                  defaultChecked
                  name="akkoord"
                  value={this.state.akkoord}
                  onChange={this.handleInputChange}
                />
                <span className="slider-checkbox round" />
              </label>{" "}
              <br />
              <label>Status</label>
              <label className="switch">
                <input
                  id="beheereenheid_active"
                  type="checkbox"
                  defaultChecked
                  name="actief"
                  value={this.state.actief}
                  onChange={this.handleInputChange}
                />
                <span className="slider-checkbox round" />
              </label>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn-modal"
                onClick={this.handleSubmit.bind(this)}
              >
                Verwerken
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateObligations;
